export const questionsAndAnswers = {
    en: [


        {
            title: "What legal actions can domestic workers take in case of a breach of contract?",
            content: "Domestic workers can approach the District Board or appropriate legal bodies in case of any breach of contract, and they are protected under the Domestic Workers Act 2008."
        },
        {
            title: "Are employers required to give a written contract to domestic workers?",
            content: "Yes, a written contract detailing the terms of employment, salary, benefits, and other relevant details is mandatory as per the provisions of the Domestic Workers Act 2008."
        },
        {
            title: "How are domestic workers' holidays regulated?",
            content: "Domestic workers are entitled to weekly offs and other national holidays. Any work done on these days is eligible for overtime pay, as stipulated by the act."
        },
        {
            title: "What legal actions can domestic workers take in case of a breach of contract?",
            content: "Domestic workers can approach the District Board or appropriate legal bodies in case of any breach of contract, and they are protected under the Domestic Workers Act 2008."
        },
        {
            title: "Are employers required to give a written contract to domestic workers?",
            content: "Yes, a written contract detailing the terms of employment, salary, benefits, and other relevant details is mandatory as per the provisions of the Domestic Workers Act 2008."
        },
        {
            title: "How are domestic workers' holidays regulated?",
            content: "Domestic workers are entitled to weekly offs and other national holidays. Any work done on these days is eligible for overtime pay, as stipulated by the act."
        }
    ],
    hi: [


        {
            title: "संविधानिक उल्लंघन के मामले में घरेलू कामकाजी क्या कानूनी कार्रवाई कर सकते हैं?",
            content: "घरेलू कामकाजी किसी भी संविधानिक उल्लंघन के मामले में जिला बोर्ड या उपयुक्त कानूनी निकायों से संपर्क कर सकते हैं, और वे घरेलू कामकाजी अधिनियम 2008 के तहत सुरक्षित हैं।"
        },
        {
            title: "क्या नियोक्ता को घरेलू कामकाजी को लिखित अनुबंध देना चाहिए?",
            content: "हां, नौकरी की शर्तों, वेतन, लाभ और अन्य संबंधित विवरण का विवरण देने वाला एक लिखित अनुबंध घरेलू कामकाजी अधिनियम 2008 की प्रावधानों के अनुसार अनिवार्य है।"
        },
        {
            title: "घरेलू कामकाजी की अवकाश कैसे विनियमित किए जाते हैं?",
            content: "घरेलू कामकाजी को साप्ताहिक अवकाश और अन्य राष्ट्रीय अवकाश का हक है। इन दिनों किए गए किसी भी काम के लिए ओवरटाइम वेतन का पात्र है, जैसा कि अधिनियम द्वारा प्रतिपादित है।"
        },

        {
            title: "संविधानिक उल्लंघन के मामले में घरेलू कामकाजी क्या कानूनी कार्रवाई कर सकते हैं?",
            content: "घरेलू कामकाजी किसी भी संविधानिक उल्लंघन के मामले में जिला बोर्ड या उपयुक्त कानूनी निकायों से संपर्क कर सकते हैं, और वे घरेलू कामकाजी अधिनियम 2008 के तहत सुरक्षित हैं।"
        },
        {
            title: "क्या नियोक्ता को घरेलू कामकाजी को लिखित अनुबंध देना चाहिए?",
            content: "हां, नौकरी की शर्तों, वेतन, लाभ और अन्य संबंधित विवरण का विवरण देने वाला एक लिखित अनुबंध घरेलू कामकाजी अधिनियम 2008 की प्रावधानों के अनुसार अनिवार्य है।"
        },
        {
            title: "घरेलू कामकाजी की अवकाश कैसे विनियमित किए जाते हैं?",
            content: "घरेलू कामकाजी को साप्ताहिक अवकाश और अन्य राष्ट्रीय अवकाश का हक है। इन दिनों किए गए किसी भी काम के लिए ओवरटाइम वेतन का पात्र है, जैसा कि अधिनियम द्वारा प्रतिपादित है।"
        }
    ]
};
